import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';
import * as validFunc from 'libs/validation';

import { Image, Popup } from 'semantic-ui-react';
import moment from 'moment';

import {
  ReduxFormDatePicker,
  ReduxFormSemanticDropdown,
  ReduxFormHiddenRecord,
  ReduxFormMaterialSwitch,
  ReduxFormMaterialSelect,
  TemplateOptionList,
  StartExamLicenseMessage
} from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

class StartExamWizardContentStep4 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // state
    const {
      loadingTemplate,
      isAttachScreenView,
      attachScreenLockDate,
      templateSelectCount,
      licenseResult,
      examSystemUrl
    } = this.props;
    // template 선택
    const {
      formStore,
      fieldInfo,
      endDate,
      templateData,
      initTemplates,
      templateAttach,
      templateAttachIndex,
      setSelectTemplate,
      onChangeScreenDate
    } = this.props;

    // const refreshTemplate = () => {
    //   if (!loadingTemplate) {
    //     this.setState({ loadingTemplate: true });
    //   }
    //   initTemplates();
    //   this.setState({ loadingTemplate: false });
    // };

    const templateDataObj = {};
    const templateDataType = {};
    if (templateData && Array.isArray(templateData)) {
      for (let i = 0, l = templateData.length; i < l; i++) {
        const d = templateData[i];

        const attachInfo = templateAttach.get(String(templateAttachIndex.get(String(d.attachInfoNo))));

        const inner = {
          key: i,
          value: i + '+' + d.templateNo + '+' + (d.serviceTemplateNo || ''),
          text: d.templateName,
          data: {
            image:
              // 경고 안내
              (d.examType === 1 && attachInfo && attachInfo.get('attachExamType') === 1 && 'warning') ||
              // 모의 악성파일
              (d.examType === 1 && attachInfo && attachInfo.get('attachExamType') === 2 && 'file') ||
              // 실태 조사
              (d.examType === 1 && attachInfo && attachInfo.get('attachExamType') === 3 && 'research') ||
              // 피싱 유도
              (d.examType === 4 && 'phishing'),
            color:
              // 경고 안내
              (d.examType === 1 && attachInfo && attachInfo.get('attachExamType') === 1 && 'color-bg-warning') ||
              // 모의 악성파일
              (d.examType === 1 && attachInfo && attachInfo.get('attachExamType') === 2 && 'color-bg-file') ||
              // 실태 조사
              (d.examType === 1 && attachInfo && attachInfo.get('attachExamType') === 3 && 'color-bg-research') ||
              // 피싱 유도
              (d.examType === 4 && 'color-bg-phishing')
          },
          content: <TemplateOptionList templateData={templateData[i]} />,
          className: cx('template-item', d.templateReceive === 1 ? 'receive-confirmed' : '')
        };

        templateDataObj[d.templateName + '_-_' + i] = inner;
        templateDataType[d.templateName + '_-_' + i] = d.serviceNo ? true : false;
      }
    }

    // 정렬 처리 - 대상자가 있는 태그순, ㄱㄴㄷ순
    const sortArray = Object.keys(templateDataObj).sort();
    const sysTemps = [];
    const userTemps = [];
    for (let i = 0, l = sortArray.length; i < l; i++) {
      if (templateDataType[sortArray[i]]) {
        userTemps.push(templateDataObj[sortArray[i]]);
      } else {
        sysTemps.push(templateDataObj[sortArray[i]]);
      }
    }

    const templateOptions = userTemps.concat(sysTemps);

    const selectTemplate = (e, value) => {
      const returnData = { isAttachScreenView: false, tempName: [] };
      if (templateData && Array.isArray(templateData) && value.length > 0) {
        for (let j = 0, m = value.length; j < m; j++) {
          const info = value[j].split('+');
          const d = templateData[info[0]];
          const attachInfo = templateAttach.get(String(templateAttachIndex.get(String(d.attachInfoNo))));

          // 훈련 유형  1: 경고 안내  2: 모의 악성파일  3: 실태 조사  4: 피싱 유도
          if (
            d.examType === 1 &&
            attachInfo &&
            (attachInfo.get('attachExamType') === 1 || attachInfo.get('attachExamType') === 2)
          ) {
            returnData.tempName.push(d.templateName);
          }
        }

        // 화면 잠금 기능 사용 여부 (경고 안내 or 모의 악성파일이 1개라도 있어야한다)
        if (returnData.tempName.length > 0) {
          returnData.isAttachScreenView = true;
        } else {
          // 경고안내, 악성파일 템플릿이 없으면 잠금화면 시간 비활성화 처리
          const { dispatch } = this.props;
          dispatch(change('startExam', 'attachScreenLock', 0));
        }
      }
      setSelectTemplate(returnData);
    };

    // 모의 악성파일 잠금 화면 최소 날짜 (시작일자 + 1일 or 발송 예약 기간 종료 후 + 1일)
    const addDays =
      !!formStore.values.sendReserveEnable && Number(formStore.values.sendReserveEnable) === 1
        ? Number(formStore.values.sendReservePeriod)
        : 1;
    const attachScreenMinDate = moment((addDays * 86400 + moment(formStore.values.examStartDate).unix()) * 1000);

    // 시간
    const hourArray = [];
    const minArray = [];
    for (let i = 0, l = 60; i < l; i++) {
      if (i < 24) {
        hourArray.push({
          key: i,
          value: i * 3600,
          text: i + defineMessages(formatMessage({ id: 'StartExamWizardContent_81', defaultMessage: '시' }))
        });
      }

      minArray.push({
        key: i,
        value: i * 60,
        text: i + defineMessages(formatMessage({ id: 'StartExamWizardContent_33', defaultMessage: '분' }))
      });
    }

    const urlMenuList = [];
    if (examSystemUrl && examSystemUrl.length > 0) {
      const splitArray = examSystemUrl.split('"');
      const urlList = splitArray.filter(value => value.indexOf('http') > -1);
      urlList.map((item, index) => {
        urlMenuList.push({
          key: index,
          value: item,
          text: item
        });
      });
    }

    return (
      <div className={cx('template-conf-area')}>
        <div className={cx('select-template-area')}>
          <div className={cx('template-list-title')}>
            {defineMessages(
              formatMessage({ id: 'StartExamWizardContent_48', defaultMessage: '훈련 양식(템플릿) 선택' })
            )}
            <div className={cx('templateType-icon')}>
              <Image src="/img/examStart/ico_warning.png" />
              {defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' }))}
              <Image src="/img/examStart/ico_file.png" />
              {defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' }))}
              <Image src="/img/examStart/ico_cheat.png" />
              {defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' }))}
              <Image src="/img/examStart/ico_site.png" />
              {defineMessages(formatMessage({ id: 'ExamTemplateList_16', defaultMessage: '피싱 유도' }))}
            </div>
          </div>
          <div className={cx('list-list')}>
            <div className={cx('list-dropdown', 'drop-area')}>
              <ReduxFormHiddenRecord
                name="examTemplateSelected"
                validate={['examTemplateRequried']}
                valuePass={templateSelectCount}
              />
              <ReduxFormSemanticDropdown
                placeholder={
                  // fieldInfo.examTemplate.label +
                  // ' ' +
                  // defineMessages(formatMessage({ id: 'StartExamWizardContent_15', defaultMessage: '선택' }))
                  validFunc.examTemplateRequried()
                }
                name="examTemplate"
                className={cx('list-template')}
                fluid
                multiple
                search
                selection
                selectOnBlur={false}
                options={templateOptions}
                loading={loadingTemplate}
                defaultValue={
                  formStore && formStore.values && formStore.values.examTemplate ? formStore.values.examTemplate : ''
                }
                onChange={selectTemplate}
                // validate={['templateRequired']}
                // error={fieldInfo.examTemplate.error}
                error={fieldInfo.examTemplateSelected.error || fieldInfo.examTemplate.error}
                errorMessage={formStore && formStore.syncErrors && formStore.syncErrors.examTemplateSelected}
                checkType={100}
                renderLabel={(label, index) => ({
                  className: label.data.color,
                  content: label.text,
                  image: '/img/examStart/temp_' + (label.data.image ? label.data.image : 'none') + '.png'
                })}
              />
            </div>
            {/* <Tooltip
            title={defineMessages(
              formatMessage({ id: 'StartExamWizardContent_94', defaultMessage: '선택한 템플릿 전체 삭제' })
            )}
            placement="bottom">
            <div className={cx('list-refresh')} onClick={refreshTemplate}>
              <Icon link name="refresh" />
            </div>
          </Tooltip> */}
          </div>
        </div>

        <div className={cx('examSystemUrl-area')}>
          <div className={cx('examSystemUrl')}>
            <div>
              <div className={cx('bold')}>
                {fieldInfo.useExamSystemUrl.label}
              </div>
              <Popup
                position="right center"
                trigger={<Image className={cx('ml-5')} src="/img/examStart/btn_qmark.png" />}
                content={
                  defineMessages(
                    formatMessage({
                      id: 'StartExamWizardContent_124',
                      defaultMessage: '메일 링크에 들어갈 URL을 설정합니다.'
                    })
                  )
                }
              />
            </div>
            <div className={cx('examSystemUrl-switch')}>
              {/* <ReduxFormHiddenRecord name="useExamSystemUrl" valuePass={isAttachScreenView} /> */}
              <ReduxFormMaterialSwitch
                className={cx('input-switch')}
                name="useExamSystemUrl"
                value={formStore.values.useExamSystemUrl ? 1 : 0}
              />
            </div>
          </div>
          <div
            className={cx('examSystemUrl-content', {
              disabled: !isAttachScreenView
            })}>
            <div className={cx('examSystemUrl-select')}>
              <span className={cx('materialTextField-title')}>{fieldInfo.examSystemUrl.label}</span>
              <ReduxFormMaterialSelect
                disabled={formStore.values.useExamSystemUrl !== "1" || urlMenuList.length < 1}
                name="examSystemUrl"
                fullWidth
                menuList={urlMenuList}
                checkType={101}
              />
            </div>
          </div>
        </div>


        <div className={cx('attachScreen-area')}>
          <div className={cx('attachScreen')}>
            <div>
              <div className={cx('bold')}>
                {defineMessages(
                  formatMessage({
                    id: 'StartExamWizardContent_31',
                    defaultMessage: 'PC 잠금 화면 실행 시간'
                  })
                )}
              </div>
              <Popup
                position="right center"
                trigger={<Image className={cx('ml-5')} src="/img/examStart/btn_qmark.png" />}
                content={ReactHtmlParser(
                  defineMessages(
                    formatMessage({
                      id: 'StartExamWizardContent_91',
                      defaultMessage:
                        '<div>' +
                        "<div>대상자가 <b>'경고 안내, 모의 악성파일'</b></div>" +
                        '<div>타입의 첨부 파일을 실행시</div>' +
                        "<div>PC에서 <b>'PC 잠금 화면'</b>의 실행시간을 </div>" +
                        '예약 할 수 있습니다.</div>' +
                        '</div>'
                    })
                  )
                )}
              />
            </div>
            <div className={cx('attachScreen-switch')}>
              <ReduxFormHiddenRecord name="isAttachScreenView" valuePass={isAttachScreenView} />
              <Popup
                trigger={
                  <div>
                    <ReduxFormMaterialSwitch
                      className={cx('input-switch')}
                      name="attachScreenLock"
                      value={formStore.values.attachScreenLock ? 1 : 0}
                      disabled={!isAttachScreenView}
                    />
                  </div>
                }
                position="top center">
                {ReactHtmlParser(
                  defineMessages(
                    formatMessage({
                      id: 'StartExamWizardContent_90',
                      defaultMessage:
                        "<div><div><b>'경고 안내, 모의 악성파일'</b>타입의</div><div>템플릿을 선택해야 <b>잠금 시간</b>을</div><div>지정 할 수 있습니다.</div></div>"
                    })
                  )
                )}
              </Popup>
            </div>
          </div>
          <div
            className={cx('attachScreen-content', {
              disabled: !isAttachScreenView
            })}>
            <div className={cx('attachScreenLock-date')}>
              <span className={cx('materialTextField-title')}>{fieldInfo.attachScreenLockDate.label}</span>
              <ReduxFormDatePicker
                disabled={!isAttachScreenView || formStore.values.attachScreenLock !== '1'}
                defaultValue={attachScreenMinDate}
                name="attachScreenLockDate"
                fullWidth
                className={cx('date-input')}
                locale={localStorage.getItem('language')}
                shouldCloseOnSelect={false}
                showYearDropdown
                dropdownMode="select"
                showMonthDropdown
                dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                minDate={attachScreenMinDate}
                maxDate={endDate}
                value={attachScreenLockDate}
                onChange={onChangeScreenDate}
                // inputLabel={fieldInfo.attachScreenLockDate.label}
                checkType={100}
                validate={['dateRequired', 'reduxFormDatePicker']}
                // disabled={!isAttachScreenView}
                noerror
                error={
                  !!(
                    common.epochFromDate(formStore.values.examEndDate) <=
                    common.epochFromDate(formStore.values.attachScreenLockDate)
                  )
                }
                helperText={
                  !!(
                    common.epochFromDate(formStore.values.examEndDate) <=
                    common.epochFromDate(formStore.values.attachScreenLockDate)
                  )
                    ? defineMessages(
                      formatMessage({
                        id: 'StartExamWizardContent_96',
                        defaultMessage: '훈련 종료일보다 이전 날짜를 선택하세요'
                      })
                    )
                    : ''
                }
              />
            </div>
            <div className={cx('attachScreenLock-time')}>
              <span className={cx('materialTextField-title')}>{fieldInfo.attachScreenLockHour.label}</span>
              <ReduxFormMaterialSelect
                disabled={!isAttachScreenView || formStore.values.attachScreenLock !== '1'}
                defaultValue={0}
                name="attachScreenLockHour"
                fullWidth
                menuList={hourArray}
                checkType={101}
              // disabled={!isAttachScreenView}
              />
            </div>
            <div className={cx('attachScreenLock-time')}>
              <span className={cx('materialTextField-title')}>{fieldInfo.attachScreenLockMin.label}</span>
              <ReduxFormMaterialSelect
                disabled={!isAttachScreenView || formStore.values.attachScreenLock !== '1'}
                defaultValue={0}
                name="attachScreenLockMin"
                fullWidth
                menuList={minArray}
                checkType={101}
              />
            </div>
          </div>
        </div>
        <div className={cx('attachScreen-info-text')}>
          {defineMessages(
            formatMessage({
              id: 'StartExamWizardContent_100',
              defaultMessage:
                "※ 선택한 템플릿 중 '경고안내', '모의 악성파일'은 PC잠금 화면의 실행시간을 예약 할 수 있습니다."
            })
          )}
        </div>
        {!!licenseResult && !licenseResult.isValidLicense ? (
          <StartExamLicenseMessage licenseResult={licenseResult} step={4} />
        ) : (
            ''
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  templateAttach: state.templateAttach.getIn(['data', 'success']),
  templateAttachIndex: state.templateAttach.get('listIndexByNo'),
  // templateAttachIndex: state.admin.get('listIndexByNo')
});

export default connect(mapStateToProps)(injectIntl(StartExamWizardContentStep4));



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardContentStep4.js